export const AppColors = {
  mainColor: '#427317"',
  borderColor: '#ccc',
  greyColor: '#B7B7B7',
  white: '#fff',
  black: '#000',
  silverGrey: '#9E9E9E',
  orange: '#ff8b00',
  whatsAppIconColor: '#34a728',
  gray: '#d9d9d9',
  lightGrey: 'lightgrey',
  linkColor: '#007bff',
  appIconColor1: '#ff0000d3',
  appIconColor2: '#1caa1c',
  red: 'red',
  appointment :"#1e5631"
};
